import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { uploadCertificationAPI, uploadFrameworkAPI } from '../../../apiConfig/apiCall';
import SampleCSVFileForCertificateUpload from '../../../csvFiles/fc-sample.csv';
import { getCertificationList } from '../../../slices/ManageCompliance/thunk';

export default function UploadFrameworkModal({
    uploadFrameworkModal,
    setUploadFrameworkModal,
    toggleUploadFrameworkModal,
    refreshComponent
}) {

    const dispatch = useDispatch();
    const [submittingForm, setSubmittingForm] = useState(false);

    const handleDownloadSampleFile = () => {
        const link = document.createElement('a');
        link.href = SampleCSVFileForCertificateUpload;
        link.download = 'fc-sample.csv';
        link.click();
    };

    const initialFormData = {
        frameworkName: "",
        overview: "",
        csvFile: null
    };

    const [formDataUploadFramework, setFormDataUploadFramework] = useState(initialFormData);

    const handleChangeUploadFramework = (field, value) => {
        if (field === 'frameworkName' && value.length > 20) {
            toast.error('Framework Name cannot exceed 20 characters.');
        } else if (field === 'overview' && value.length > 200) {
            toast.error('Overview cannot exceed 200 characters.');
        } else {
            setFormDataUploadFramework(prevState => ({
                ...prevState,
                [field]: value
            }));
        }
    };

    const handleFileChange = (file) => {
        if (file) {
            const fileExtension = file.name.split('.').pop().toLowerCase();

            if (fileExtension !== 'csv') {
                toast.error("Only CSV files are allowed.");
                return;
            }
            setFormDataUploadFramework((prevState) => ({
                ...prevState,
                csvFile: file,
            }));
        } else {
            toast.error("Please select a file.");
        }
    };

    const handleReset = () => {
        setFormDataUploadFramework(initialFormData);
    };

    const handleSubmitUploadFramework = async (e) => {
        e.preventDefault();
        if (submittingForm) return;
        try {
            const { frameworkName, overview, csvFile } = formDataUploadFramework;

            if (!frameworkName) {
                toast.error('Framework Name is required');
                return;
            } else if (frameworkName.length > 20) {
                toast.error('Framework Name must be a maximum of 20 characters');
                return;
            }

            else if (!overview) {
                toast.error('Overview is required');
                return;
            } else if (overview.length > 200) {
                toast.error('Overview must be a maximum of 200 characters');
                return;
            }

            else if (!csvFile) {
                toast.error('CSV File is required');
                return;
            }

            const dataToSubmit = {
                frameworkName,
                overview,
                file: csvFile
            };

            setSubmittingForm(true);
            const apiResponse = await uploadFrameworkAPI(dataToSubmit);
            if (apiResponse.status === 200) {
                toast.success(apiResponse.data);
                setUploadFrameworkModal(false);
                refreshComponent();
            }
            else if (apiResponse.status === 400) {
                toast.error(apiResponse.data);
            }
            else {
                toast.error(apiResponse.data);
            }
        } catch (error) {
            console.error('Error sending data:', error);
            toast.error('An error occurred while uploading the framework');
        } finally {
            setSubmittingForm(false);
        }
    };

    return (
        <>
            <Modal isOpen={uploadFrameworkModal} toggle={toggleUploadFrameworkModal} size='lg'>
                <ModalHeader toggle={toggleUploadFrameworkModal}>
                    Upload Framework
                    <Button
                        color="primary"
                        className="waves-effect waves-light material-shadow-none mx-3"
                        outline
                        onClick={handleDownloadSampleFile}
                    >
                        <i className="ri-download-2-line me-2" />
                        Download Sample File
                    </Button>
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <Row className="gy-3">
                            <Col lg={6}>
                                <div>
                                    <Label htmlFor="frameworkName" className="form-label">Framework Name</Label>
                                    <Input
                                        type="text"
                                        className="form-control"
                                        id="frameworkName"
                                        value={formDataUploadFramework.frameworkName}
                                        onChange={(e) => handleChangeUploadFramework('frameworkName', e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div>
                                    <Label htmlFor="overview" className="form-label">Overview</Label>
                                    <Input
                                        type="text"
                                        className="form-control"
                                        id="overview"
                                        value={formDataUploadFramework.overview}
                                        onChange={(e) => handleChangeUploadFramework('overview', e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div>
                                    <Label htmlFor="csvFile" className="form-label">CSV File</Label>
                                    <Input
                                        type="file"
                                        className="form-control"
                                        id="csvFile"
                                        onChange={(e) => handleFileChange(e.target.files[0])}
                                    />
                                </div>
                            </Col>
                            <Col lg={12}>
                                {
                                    submittingForm ?
                                        <Button color="primary" className="me-2" type='button' disabled>
                                            <Spinner size="sm"> Loading... </Spinner>
                                        </Button>
                                        :
                                        <Button color="primary" type="submit" className="me-2" disabled={submittingForm} onClick={handleSubmitUploadFramework}>
                                            Upload
                                        </Button>
                                }
                                <Button color="secondary" type="reset" disabled={submittingForm} onClick={handleReset} > Reset </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    );
}